import { createContext, useContext, useState } from "react";

const AppContext = createContext({});

export const useAppContext = () => useContext(AppContext);

export const ContextWrapper = ({ children }) => {
    const [searchInput, setSearchInput] = useState('');

    return (
        <AppContext.Provider value={{ searchInput, setSearchInput }}>
            {children}
        </AppContext.Provider>
    )
}

export default ContextWrapper;